import { Component } from '@angular/core';

@Component({
  selector: 'app-icon-loading',
  templateUrl: './icon-loading.component.svg',
  styleUrls: ['./icon-loading.component.css'],
})
export class IconLoadingComponent {}
